import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Button, Table, DatePicker, Spin, Select} from 'antd'
import {MinusOutlined, PlusOutlined} from '@ant-design/icons'
import {alertMessage} from '../../../utils'
import * as PropTypes from 'prop-types'
import {inject, observer} from 'mobx-react'
import {toJS} from 'mobx'
import moment from 'moment'
import ImportModal from './ImportModal'
import {withTranslation} from 'react-i18next'

function MinusCircleOutlined() {
  return null
}

MinusCircleOutlined.propTypes = {onClick: PropTypes.func}

@inject('rulesManagementStore', 'uiState')
@observer
class RulesModal extends Component {
  formRef = React.createRef()
  state = {
    visibleDate: false,
    tableNameNotSelected: true,
    canNotEdit: false,
    exportIsClicked: false,
    importModalVisible: false,
    importData: {},
    joinDisabled: false,
    canExport: true,
    canChangeRuleName: false,
    addRuleSetList: [{field: {value: '', label: ''}, fieldValueOrigin: ''}],
    addRuleWhereOriginList: [{parent: [{field: {value: '', label: ''}, operator: '', valueType: '', valueOrigin: '', joinType: ''}]}]
  }

  componentDidMount() {
    const {rulesManagementStore, rulesModalType} = this.props

    rulesManagementStore.getDropdown('RuleTriggerTypeEnum')
    rulesManagementStore.getDropdown('RuleWhereOperatorEnum')
    rulesManagementStore.getDropdown('RuleWhereTypeEnum')
    rulesManagementStore.getDropdown('RuleWhereJoinEnum')

    if (rulesModalType === 'edit') {
      this.editInit()
    }
    if (rulesModalType === 'check') {
      this.editInit()
      this.setState({tableNameNotSelected: true, canNotEdit: true, canChangeRuleName: true, joinDisabled: true})
    }
  }

  editInit = () => {
    const {rulesManagementStore} = this.props
    const {ruleDetail} = rulesManagementStore
    this.setState({tableNameNotSelected: false})
    if (ruleDetail.triggerDate) this.setState({visibleDate: true})

    ruleDetail.ruleSetList.forEach((item, index) => this.setState({['field' + index]: item.fieldType === 'date'}))
    ruleDetail.addRuleWhereOriginList.forEach((item, index) => {
      item.parent.forEach((subItem, subIndex) => {
        this.setState({
          ['whereFiled' + subIndex + index]: subItem.fieldType,
          ['whereValueType' + subIndex + index]: subItem.valueType
        })
      })
    })

    this.formRef.current.setFieldsValue({
      ...ruleDetail,
      addRuleSetList: toJS(ruleDetail.ruleSetList),
      addRuleWhereOriginList: toJS(ruleDetail.addRuleWhereOriginList)
    })
  }

  handleOk = () => {
    const {handleCancel, handleSearch, rulesManagementStore, rulesModalType, ruleId} = this.props

    this.formRef.current.validateFields().then(fieldsValue => {
      if (fieldsValue.ruleName.trim().length === 0) {
        return alertMessage.error('Please enter Rule Name.')
      }
      rulesManagementStore.submitRule(fieldsValue, rulesModalType, ruleId).then(res => {
        if (res?.data?.code === 0) {
          handleCancel('rulesModalVisible')
          alertMessage.success(res?.data?.message).then()
          handleSearch()
        }
      })
    })
  }

  handleDel = (target, index) => {
    if (this.state[target].length > 1) {
      let origin = this.state[target]
      origin.splice(index, 1)
      this.setState({
        [target]: [...origin]
      })
    }
  }

  onTableNameChange = value => {
    const {rulesManagementStore} = this.props
    const {addRuleSetList, addRuleWhereOriginList} = this.state

    rulesManagementStore.onTableNameChange(value)
    this.setState({tableNameNotSelected: false})
    this.formRef.current.setFieldsValue({addRuleSetList, addRuleWhereOriginList})
  }

  onValueTypeChange = (e, index, parentField, type, action = true, row) => {
    const currentData = type === 'whereValueType' ? this.formRef.current.getFieldValue('addRuleWhereOriginList') : this.formRef.current.getFieldValue(type)
    const tableName = type === 'whereValueType' ? 'addRuleWhereOriginList' : type
    let lastIndex

    switch (type) {
      case 'addRuleSetList':
        lastIndex = e?.value.lastIndexOf(e.label)
        if (lastIndex === -1) {
          lastIndex = e?.value.length
        }
        this.setState({['field' + index]: e?.value.substring(0, lastIndex) === 'date'})
        if (action) {
          currentData[index]['fieldValueOrigin'] = ''
        }
        break
      case 'addRuleWhereOriginList':
        lastIndex = e?.value.lastIndexOf(e.label)
        if (lastIndex === -1) {
          lastIndex = e?.value.length
        }

        this.setState({['whereFiled' + index + parentField.key]: e?.value.substring(0, lastIndex)})
        if (action) {
          if (parentField.key >= currentData.length) {
            currentData[currentData.length - 1]['parent'][index]['valueOrigin'] = null
          } else {
            currentData[parentField.key]['parent'][index]['valueOrigin'] = null
          }
        } else {
          this.setState({['whereValueType' + index + parentField.key]: row.valueType})
        }
        break
      default:
        this.setState({['whereValueType' + index + parentField.key]: e})
        if (action) {
          if (parentField.key >= currentData.length) {
            currentData[currentData.length - 1]['parent'][index]['valueOrigin'] = null
          } else {
            currentData[parentField.key]['parent'][index]['valueOrigin'] = null
          }
        }
        break
    }

    this.formRef.current.setFieldsValue({
      [tableName]: currentData
    })
  }

  onDelete = (type, callback, index, parentKey) => {
    callback(index)
    const currentList = this.formRef.current.getFieldValue(type)
    if (type === 'addRuleSetList') {
      currentList.forEach((item, listIndex) => {
        this.onValueTypeChange(item.field, listIndex, '', type, false)
      })
    } else if (!parentKey) {
      currentList.forEach((item, mainIndex) => {
        item['parent'].forEach((subItem, subIndex) => {
          if (subItem?.field) {
            this.onValueTypeChange(subItem.field, subIndex, {'key': mainIndex}, type, false, subItem)
          }
        })
      })
    } else {
      currentList.forEach(item => {
        item['parent'].forEach((thirdItem, thirdIndex) => {
          if (thirdItem?.field) {
            this.onValueTypeChange(thirdItem.field, thirdIndex, {'key': parentKey}, type, false, thirdItem)
          }
        })
      })
    }
  }

  handleExport = () => {
    const {rulesManagementStore, uiState} = this.props
    const dateTime = moment().format('YYYY-MM-DD')

    this.setState({canExport: false})
    this.formRef.current.validateFields().then(fieldsValue => {
      this.setState({exportIsClicked: true, tableNameNotSelected: true, canNotEdit: true, joinDisabled: true})
      const params = rulesManagementStore.submitFormat(fieldsValue)
      uiState.onChangeFetchingExport('/api/v1/rule/exportRule', params, `${fieldsValue.ruleName + '_' + dateTime}.xlsx`)
    })
  }

  handleImport = () => {
    this.setState({importModalVisible: true, importData: this.formRef.current.getFieldValue()})
  }

  render() {
    const {
      visibleDate,
      tableNameNotSelected,
      addRuleSetList,
      addRuleWhereOriginList,
      exportIsClicked,
      canNotEdit,
      importModalVisible,
      importData,
      joinDisabled,
      canExport,
      canChangeRuleName
    } = this.state
    const {rulesModalVisible, handleCancel, rulesManagementStore, rulesModalType, handleSearch, ruleName, t} = this.props
    const {isFetching, tableList, triggerTypeList, filedList, operatorList, valueTypeList, joinList} = rulesManagementStore

    return (
      <Spin spinning={isFetching}>
        <Modal
          title={`${rulesModalType === 'add' ? t(`rulesManagement.addRules`) : rulesModalType === 'edit' ? t(`rulesManagement.editRules`) : ruleName}`}
          width="70%"
          closable={true} onCancel={() => handleCancel('rulesModalVisible')} visible={rulesModalVisible}
          maskClosable={false} destroyOnClose={true} centered
          footer={[
            <Button disabled={canNotEdit} key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={() => handleCancel('rulesModalVisible')}>{t(`general.cancel`)}</Button>
          ]}
        >
          <Form ref={this.formRef} key="rulesModal" layout="vertical">
            <Row gutter={[10, 0]}>
              <Col span={24} style={{textAlign: 'right', marginBottom: '10px'}}>
                <Button style={{marginRight: 10, width: 'auto'}} type="primary" disabled={!exportIsClicked}
                        onClick={this.handleImport}>{t(`general.import`)}</Button>
                <Button type="primary" disabled={canNotEdit} onClick={this.handleExport}>{t(`general.export`)}</Button>
              </Col>
            </Row>

            <Row gutter={[10, 0]}>
              <Col span={6}>
                <Form.Item name="ruleName" label={t(`rulesManagement.ruleName`)}
                           rules={[
                             {
                               required: true,
                               message: `${t(`general.pleaseEnter`)} ${t(`rulesManagement.ruleName`)} ${t(`general.withoutSpecialChats`)}`,
                               pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                             }
                           ]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} disabled={canChangeRuleName}/>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name="tableName" label={t(`rulesManagement.tableName`)}
                           rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.tableName`)}`}]}>
                  <Select placeholder={t(`general.pleaseSelect`)} showSearch onChange={e => this.onTableNameChange(e)} disabled={canNotEdit}>
                    {tableList?.map(item => <Select.Option key={item.tableName} value={item.tableName}>{item.tableName}</Select.Option>)}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name="triggerType" label={t(`rulesManagement.triggerType`)}
                           rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.triggerType`)}`}]}>
                  <Select placeholder={t(`general.pleaseSelect`)} onChange={e => this.setState({visibleDate: e === 'PROACTIVE'})}
                          disabled={canNotEdit}>
                    {triggerTypeList?.map(item => <Select.Option key={item.code} value={item.code}>{item.name}</Select.Option>)}
                  </Select>
                </Form.Item>
              </Col>

              {
                visibleDate ?
                  <Col span={6} style={{marginTop: 30}}>
                    <Form.Item name="triggerDateOrigin" label=""
                               rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.date`)}`,}]}>
                      <DatePicker placeholder={t(`general.pleaseSelect`)} showTime format="YYYY-MM-DD HH:00" disabled={canNotEdit} style={{width: '100%'}}/>
                    </Form.Item>
                  </Col> : null
              }
            </Row>

            <Row gutter={[10, 0]}>
              <Form.List name="addRuleSetList" initialValue={addRuleSetList}>
                {(fields, {add, remove}) => (
                  <>
                    <Col span={24}>
                      <Table dataSource={fields} pagination={false} className="searchResult" style={{ padding: 0, margin: 0 }}>
                        <Table.Column title={t(`rulesManagement.filed`)} dataIndex="filed" key="filed" width="315px"
                                      render={(text, row, index) => {
                                        return (
                                          <Form.Item name={[row.name, 'field']} rules={[
                                            {required: true, message: ''},
                                            () => ({
                                              validator(_, value) {
                                                if (value.value) {
                                                  return Promise.resolve()
                                                }

                                                return Promise.reject(new Error(`${t(`general.pleaseSelect`)} ${t(`rulesManagement.filed`)}`))
                                              },
                                            })
                                          ]}>
                                            <Select onChange={e => this.onValueTypeChange(e, index, '', 'addRuleSetList')} labelInValue showSearch
                                                    disabled={tableNameNotSelected}
                                            >
                                              {filedList?.map(item => <Select.Option key={item?.fieldName}
                                                                                    value={item?.fieldType + item?.fieldName}>{item?.fieldName}</Select.Option>)}
                                            </Select>
                                          </Form.Item>
                                        )
                                      }}/>

                        <Table.Column title={t(`rulesManagement.value`)} dataIndex="fieldValue" key="fieldValue"
                                      render={(text, row, index) => {
                                        return (
                                          <>
                                            {
                                              this.state['field' + index] ?
                                                <Form.Item name={[row.name, 'fieldValueOrigin']}
                                                           rules={[{
                                                             required: canExport,
                                                             message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.value`)}`,
                                                           }]}>
                                                  <DatePicker style={{width: '100%'}} showTime disabled={tableNameNotSelected}/>
                                                </Form.Item> :
                                                <Form.Item name={[row.name, 'fieldValueOrigin']}
                                                           rules={[
                                                             {
                                                               required: canExport,
                                                               message: `${t(`general.pleaseEnter`)} ${t(`rulesManagement.value`)} ${t(`general.withoutSpecialChats`)}`,
                                                               pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                                             }
                                                           ]}>
                                                  <Input disabled={tableNameNotSelected}/>
                                                </Form.Item>
                                            }
                                          </>
                                        )
                                      }}/>

                        <Table.Column align="center" title={t(`general.action`)} key="Action" render={(text, row, index) => (
                          <>
                            <Button type="link" onClick={() => add()} icon={<PlusOutlined/>} disabled={tableNameNotSelected}
                                    title={t(`general.add`)}/>
                            {
                              fields.length > 1 ?
                                <Button type="link" onClick={() => this.onDelete('addRuleSetList', remove, index)} icon={<MinusOutlined/>}
                                        title={t(`general.delete`)}
                                        disabled={canNotEdit}/> : null
                            }
                          </>
                        )}/>
                      </Table>
                    </Col>
                  </>
                )}
              </Form.List>
            </Row>

            <Row gutter={[10, 0]}>
              <Form.List name="addRuleWhereOriginList" initialValue={addRuleWhereOriginList}>
                {(parentFields, {add, remove}) => (
                  <>
                    <Col span={4} style={{padding: '20px 0 20px 5px'}}>
                      <Button key="add" type="primary" style={{width: 'auto'}} onClick={() => add()}
                              disabled={canNotEdit}>{t(`rulesManagement.addGroup`)}</Button>
                    </Col>

                    {
                      parentFields?.map((parentField) => (
                        <Form.List label="parent" name={[parentField.name, 'parent']} fieldKey={[parentField.fieldKey, 'parent']}
                                   key={[parentField.key, 'parent']} initialValue={addRuleWhereOriginList}>
                          {(childFields, {add: addChild, remove: removeChild}) => (
                            <>
                              <Col span={24}>
                                <Table dataSource={childFields}
                                       pagination={false}
                                       className="searchResult"
                                       style={{ padding: 0, margin: 0 }}>
                                  <Table.Column title={t(`rulesManagement.filed`)} dataIndex="field" key="field" width="200px"
                                                render={(text, row, index) => {
                                                  return (
                                                    <Form.Item name={[row.name, 'field']}
                                                               rules={[
                                                                 {required: true, message: ''},
                                                                 () => ({
                                                                   validator(_, value) {
                                                                     if (value?.value) {
                                                                       return Promise.resolve()
                                                                     }

                                                                     return Promise.reject(new Error(`${t(`general.pleaseSelect`)} ${t(`rulesManagement.filed`)}`))
                                                                   }
                                                                 })
                                                               ]}>
                                                      <Select labelInValue showSearch
                                                              onChange={e => this.onValueTypeChange(e, index, parentField, 'addRuleWhereOriginList')}
                                                              disabled={tableNameNotSelected}
                                                      >
                                                        {filedList?.map(item => <Select.Option key={item?.fieldName}
                                                                                              value={item?.fieldType + item?.fieldName}>{item?.fieldName}</Select.Option>)}
                                                      </Select>
                                                    </Form.Item>
                                                  )
                                                }}/>

                                  <Table.Column title={t(`rulesManagement.operator`)} dataIndex="operator" key="operator" width="190px"
                                                render={(text, row) => {
                                                  return (
                                                    <Form.Item name={[row.name, 'operator']}
                                                               rules={[{
                                                                 required: true,
                                                                 message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.operator`)}`,
                                                               }]}>
                                                      <Select disabled={tableNameNotSelected}
                                                      >
                                                        {operatorList?.map(item => <Select.Option key={item?.code}
                                                                                                 value={item?.code}>{item?.name}</Select.Option>)}
                                                      </Select>
                                                    </Form.Item>
                                                  )
                                                }}/>

                                  <Table.Column title={t(`rulesManagement.valueType`)} dataIndex="valueType" key="valueType" width="200px"
                                                render={(text, row, index) => {
                                                  return (
                                                    <Form.Item name={[row.name, 'valueType']} rules={[{
                                                      required: true,
                                                      message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.valueType`)}`,
                                                    }]}>
                                                      <Select disabled={tableNameNotSelected}
                                                              onChange={e => this.onValueTypeChange(e, index, parentField, 'whereValueType')}
                                                      >
                                                        {valueTypeList?.map(item => <Select.Option key={item?.code}
                                                                                                  value={item?.code}>{item?.name}</Select.Option>)}
                                                      </Select>
                                                    </Form.Item>
                                                  )
                                                }}/>

                                  <Table.Column title={t(`rulesManagement.value`)} dataIndex="value" key="value" width="200px"
                                                render={(text, row, index) => {
                                                  return (
                                                    <>
                                                      {
                                                        this.state['whereFiled' + index + parentField.key] === 'date' && this.state['whereValueType' + index + parentField.key] === 'Value' ?
                                                          <Form.Item name={[row.name, 'valueOrigin']}
                                                                     rules={[{
                                                                       required: canExport,
                                                                       message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.value`)}`,
                                                                     }]}>
                                                            <DatePicker style={{width: '100%'}} showTime disabled={tableNameNotSelected}/>
                                                          </Form.Item> : this.state['whereFiled' + index + parentField.key] && this.state['whereValueType' + index + parentField.key] === 'Value' ?
                                                            <Form.Item name={[row.name, 'valueOrigin']}
                                                                       rules={[
                                                                         {
                                                                           required: canExport,
                                                                           message: `${t(`general.pleaseEnter`)} ${t(`rulesManagement.value`)} ${t(`general.withoutSpecialChats`)}`,
                                                                           pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                                                         }
                                                                       ]}>
                                                              <Input disabled={tableNameNotSelected}/>
                                                            </Form.Item> : this.state['whereFiled' + index + parentField.key] && this.state['whereValueType' + index + parentField.key] === 'Field' ?
                                                              <Form.Item name={[row.name, 'valueOrigin']}
                                                                         rules={[{
                                                                           required: canExport,
                                                                           message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.value`)}`,
                                                                         }]}>
                                                                <Select showSearch disabled={tableNameNotSelected}
                                                                >
                                                                  {filedList?.map(item => <Select.Option key={item?.fieldName}
                                                                                                        value={item?.fieldName}>{item?.fieldName}</Select.Option>)}
                                                                </Select>
                                                              </Form.Item> : null
                                                      }
                                                    </>
                                                  )
                                                }}/>

                                  <Table.Column width="80px" title={t(`rulesManagement.type`)} dataIndex="type" key="type"
                                                render={(text, row, index) => {
                                                  return (
                                                    <Form.Item>
                                                      {this.state['whereFiled' + index + parentField.key]}
                                                    </Form.Item>
                                                  )
                                                }}/>

                                  <Table.Column title={t(`rulesManagement.join`)} dataIndex="joinType" key="joinType" width="150px"
                                                render={(text, row, index) => {
                                                  return (
                                                    <Form.Item name={[row.name, 'joinType']} rules={[{
                                                      required: childFields.length.toString() !== (index + 1).toString(),
                                                      message: `${t(`general.pleaseSelect`)} ${t(`rulesManagement.join`)}`,
                                                    }]}>
                                                      <Select disabled={childFields.length.toString() === (index + 1).toString() || joinDisabled}
                                                      >
                                                        {joinList?.map(item => <Select.Option key={item?.code}
                                                                                             value={item?.code}>{}{item?.name}</Select.Option>)}
                                                      </Select>
                                                    </Form.Item>
                                                  )
                                                }}/>

                                  <Table.Column width={150} align="center" title={t(`general.action`)} key="Action"
                                                render={(text, row, index) => (
                                                  <>
                                                    <Button type="link" onClick={() => addChild()} icon={<PlusOutlined/>}
                                                            disabled={tableNameNotSelected} title={t(`general.add`)}/>
                                                    {
                                                      childFields.length > 1 ?
                                                        <Button type="link"
                                                                onClick={() => this.onDelete('addRuleWhereOriginList', removeChild, index, parentField.key)}
                                                                icon={<MinusOutlined/>}
                                                                title={t(`general.delete`)} disabled={canNotEdit}/> : null
                                                    }
                                                  </>
                                                )}/>
                                </Table>
                              </Col>
                              <Col span={24} style={{ textAlign: 'right', padding: '20px 0'}}>
                                {
                                  parentFields.length > 1 ?
                                    <Button key="add" type="primary"
                                            onClick={() => this.onDelete('addRuleWhereOriginList', remove, parentField.name, parentField.key)}
                                            disabled={canNotEdit}>{t(`general.remove`)}</Button> : null
                                }
                              </Col>
                            </>
                          )}
                        </Form.List>
                      ))
                    }
                  </>
                )}
              </Form.List>
            </Row>
          </Form>
        </Modal>

        {
          importModalVisible ? <ImportModal handleCancel={handleCancel} importCancel={() => this.setState({importModalVisible: false})}
                                            importModalVisible={importModalVisible} handleSearch={handleSearch} importData={importData}/> : null
        }
      </Spin>
    )
  }
}

export default withTranslation()(RulesModal)
